import { BASE_URL } from 'constants/api';
import actions from './index';

export const ACTIONS = {
  GET: 'TEACHER_STUDENTS_LIST_GET',
  GET_SUCCESS: 'TEACHER_STUDENTS_LIST_GET_SUCCESS',
  GET_FAILURE: 'TEACHER_STUDENTS_LIST_GET_FAILURE',
};

export const get = actions.get(
  teacherId => `${BASE_URL}/students/teacher-students/?teacher_id=${teacherId}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
